// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__G1s2a","col":"styles_col__15xZj"};